import { ResponseBase } from "./response-base";

export class ResponseDelete extends ResponseBase {

  id?: string;

}

export class ResponseDeleteIds extends ResponseBase {

  ids?: string[] | null;

}
